export default __webpack_public_path__ + "static/media/image3232.f0e53acc.jpg";